import React, { useEffect, useRef, useState } from "react";
import styles from "./StickySearchBar.module.scss";
import SearchBar from "./SearchBar";

const StickySearchBar = ({
  placeholder,
  onSearch,
  className,
  isFilterOpen,
  setIsFilterOpen,
}) => {
  const searchBarRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const node = searchBarRef.current;
    if (!node || window.innerWidth > 1024) return;

    const handleScroll = () => {
      const rect = node.getBoundingClientRect();
      const isNowSticky = rect.top <= (window.innerWidth <= 768 ? 60 : 80);
      setIsSticky(isNowSticky);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      ref={searchBarRef}
      className={`${styles.searchBarContainer} ${
        isSticky ? styles.isSticky : ""
      }`}
    >
      <SearchBar
        className={className}
        placeholder={placeholder}
        onSearch={onSearch}
        isFilterOpen={isFilterOpen}
        setIsFilterOpen={setIsFilterOpen}
      />
    </div>
  );
};

export default StickySearchBar;
